/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 优惠券去使用
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  couCondition: good.CouponProductsCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/coupon/products`,
    data: couCondition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
